import React from 'react'
import './styleCalender.css';
import { Col, Row, Table, Card, Input } from 'reactstrap';
import { Button } from 'primereact/button';
import DateRangePicker from "react-bootstrap-daterangepicker";
import { Chart } from 'primereact/chart';



export const Programming = (props) => {

    const { loadinfProgramming, detailInformation, hoveredColumn, handleExpandRow, setHoveredColumn, totalRow2, number_format,
        handleViewDetailsFilter, handleViewDetails, expandedRow, handeGeneralEvent, handleViewMonth, handleViewRange,
        viewMonth, dateFilter, setDateFilter, handleFilterDate, handleClosedViewMonth,
        viewRange, state_filter, setStart, setEnd, handleView, handleClosedViewRange, start, end, handleCalender
    } = props;

    const transformData = (data) => {
        const dates = [];
        const sumBranches = [];
        const sumBranchesCollected = [];

        data.forEach(event => {
            dates.push(event.start_date);
            sumBranches.push(event.sum_branches);
            sumBranchesCollected.push(event.sum_branches_collected);
        });

        return {
            dates,
            sumBranches,
            sumBranchesCollected
        };
    };

    const { dates, sumBranches, sumBranchesCollected } = transformData(detailInformation);


    const data =
    {
        labels: dates,
        datasets: [
            {
                label: 'Monto Recolectado',
                data: sumBranchesCollected,
                fill: true,
                borderColor: '#0e245e',
                backgroundColor: '#5a6b99ff',

                tension: 0.4
            },
            {
                label: 'Monto Programado',
                data: sumBranches,
                fill: true,

                borderColor: '#373d3f',
                backgroundColor: '#0202021a',
                tension: 0.4
            }
        ]
    };

    const options =
    {
        responsive: true,
        plugins: {
            title: {
                display: true,
                text: 'Montos recuperados en el periodo'
            },
            legend: {
                position: 'top',
            }
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Fecha'
                }
            },
            y: {
                title: {
                    display: true,
                    text: 'Monto'
                }
            }
        }
    };



    return (
        <>
            <Row>
                <Col sm="5" className='p-r-0' >
                    <Col sm="12" className='pb-2' >
                        <Row>
                            <Col sm="9">
                                {
                                    viewMonth && <Row>

                                        <Col sm="6">
                                            {viewMonth && <Input type='month' value={dateFilter} className='border-0 mr-2' onChange={(e) => { setDateFilter(e.target.value) }} />}
                                        </Col>
                                        <Col sm="1" className='pt-2 '>
                                            <i title='Buscar' className="icofont icofont-filter f-18 branches-label pointer" onClick={handleFilterDate}></i>

                                        </Col>


                                        <Col sm="1" className='pt-2'>
                                            <i title="Cancelar" className="fa fa-ban f-18 gauge-pointer pointer" onClick={handleClosedViewMonth}  >

                                            </i>
                                        </Col>
                                    </Row>
                                }
                                {//!TYPE RANGE
                                    viewRange && <Row className='pt-1' >

                                        <Col sm="7" className='p-r-0 p-l-0' style={{ textAlign: "end" }} >
                                            {
                                                state_filter &&
                                                <DateRangePicker
                                                    initialSettings={{
                                                        locale: {
                                                            format: "YYYY-MM-DD",
                                                            applyLabel: "Aplicar",
                                                            cancelLabel: "Cancelar"
                                                        },
                                                        startDate: start,
                                                        endDate: end,
                                                        timePicker: false,
                                                        drops: 'down'
                                                    }}
                                                    onApply={(event, picker) => {
                                                        const startDate = new Date(picker.startDate);
                                                        const endDate = new Date(picker.endDate);
                                                        setStart(startDate);
                                                        setEnd(endDate);
                                                        handleView(startDate, endDate);
                                                    }}
                                                >
                                                    <input className={`form-control form-control-sm input-air-primary border-primary-input`} type="text" />
                                                </DateRangePicker>
                                            }
                                            {
                                                !state_filter && <label htmlFor="">Filtros</label>
                                            }
                                        </Col>
                                        <Col sm="1">
                                            <i title="Cancelar filtro" className="fa fa-ban f-28 gauge-pointer pointer" onClick={handleClosedViewRange}  >

                                            </i>
                                        </Col>
                                    </Row>
                                }

                            </Col>
                            <Col sm="3" className='p-r-0' >
                                <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
                                    <Button
                                        icon="pi pi-clock"
                                        rounded
                                        severity="success"
                                        aria-label="Search"
                                        title='Generar evento mensual'
                                        onClick={handeGeneralEvent}
                                        style={{
                                            padding: "5px 10px",
                                            height: "35px",
                                            width: "35px",
                                            fontSize: "1rem",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center"
                                        }}
                                    />
                                    <button
                                        className="p-button p-button-warning"
                                        title="Generar consulta mensual"
                                        style={{
                                            alignItems: "center",
                                            padding: "5px 8px",
                                            height: "35px",
                                            width: "35px",
                                            fontSize: "0.9rem",
                                            display: "flex",
                                            justifyContent: "center"
                                        }}
                                        onClick={() => handleViewMonth()}
                                    >
                                        <i className="pi pi-calendar" style={{ fontSize: "1rem" }}></i>
                                    </button>
                                    <button
                                        className="p-button p-button-secondary"
                                        title="Generar búsqueda por rangos"
                                        style={{
                                            alignItems: "center",
                                            padding: "5px 8px",
                                            height: "35px",
                                            width: "35px",
                                            fontSize: "0.9rem",
                                            display: "flex",
                                            justifyContent: "center"
                                        }}
                                        onClick={() => handleViewRange()}
                                    >
                                        <i className="icofont icofont-filter" style={{ fontSize: "1rem" }}></i>
                                    </button>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Card className='shadow-sm border height-equal pricingtable mb-0 pb-0' style={{ paddingTop: "15px", paddingLeft: "5px", paddingRight: "5px", scrollBehavior: "smooth", transform: "scale(0.9)", width: "113%", transformOrigin: "top left", textAlign: "center", height: "95%" }}>
                        <label style={{ color: "#0a2754" }} className='f-w-700' >Detalle del mes</label>
                        <div className='table-wrapper-event'>
                            <Table className='b-r-5 table table-sm table custom-table'>
                                <thead className='b-r-5' style={{ textAlign: "center" }} >
                                    <tr style={{ backgroundColor: "#1d5b83", borderBottom: "#e3ebf3", borderTop: "#e3ebf3" }} >
                                        <th></th>
                                        <th style={{ color: "#fff" }} >Fecha</th>
                                        <th style={{ color: "#fff" }}>Programado</th>
                                        <th style={{ color: "#fff" }}>Recuperado</th>
                                        <th style={{ color: "#fff" }}>Indicadores</th>
                                    </tr>
                                </thead>
                                <tbody style={{ textAlign: "center" }} >
                                    {
                                        loadinfProgramming && <tr>
                                            <td colSpan={9} className=' text-center f-16'>
                                                <Col sm="12" md="12" lg="12" className='text-center pt-4'>
                                                    <img src={require("../../assets/images/loginHelenLabs/HelenLabs.png")} className='animate__animated animate__pulse animate__infinite ' style={{ width: '100px' }} /> <br /> <br />
                                                    <label className='txt-secondary f-18'>Cargando.....</label>
                                                </Col>
                                                <br />
                                            </td>
                                        </tr>
                                    }
                                    {!loadinfProgramming && detailInformation?.map((_find, _k) => (
                                        <React.Fragment key={_find?.id}>
                                            <tr onMouseEnter={() => setHoveredColumn(_k)} style={{ backgroundColor: hoveredColumn === _k ? '#01273c2b' : 'inherit' }}>
                                                <td>
                                                    <i className={`fa fa-${expandedRow === _k ? 'plus-square' : 'plus-square-o'} f-20 branches-label`} onClick={() => handleExpandRow(_k)}></i>
                                                </td>
                                                <td>{_find?.start_date ?? "------"}</td>
                                                <td className=' f-w-700'>${number_format(_find?.sum_branches, 2) ?? 0}</td>
                                                <td className='txt-danger f-w-700'>${number_format(_find?.sum_branches_collected) ?? 0}</td>
                                                {
                                                    !_find.valid ? (
                                                        <td>
                                                            <i className="fa fa-eye f-20 branches-label" onClick={() => handleViewDetails(_find.id_event)}></i>
                                                        </td>
                                                    ) : (
                                                        <td>
                                                            <i className="fa fa-eye f-20 branches-label" onClick={() => handleViewDetailsFilter(_find.id_event)}></i>
                                                        </td>
                                                    )
                                                }
                                            </tr>
                                            {expandedRow === _k && (
                                                <tr>
                                                    <td colSpan={1}></td>
                                                    <td colSpan={2} style={{ textAlign: "justify" }} >
                                                        <b className='branches-label'>Sucursales Activas</b>
                                                        {
                                                            _find.commercialBranchTreeView.map((_a) => (
                                                                _a.children.map((_x) => {
                                                                    if (_x.amount === 0) {
                                                                        return;
                                                                    }
                                                                    return (
                                                                        <div>
                                                                            <li className='branches-label'>{_x.text}</li>
                                                                        </div>
                                                                    )
                                                                })
                                                            ))
                                                        }
                                                    </td>
                                                    <td colSpan={2} style={{ textAlign: "justify" }} >
                                                        <b className='branches-label'>Montos Activos Recuperados</b>
                                                        {
                                                            _find.commercialBranchTreeView.map((_a) => (
                                                                _a.children.map((_x) => {
                                                                    if (_x.amount === 0) {
                                                                        return;
                                                                    }
                                                                    return (
                                                                        <div>
                                                                            <li className='branches-label'>${number_format(_x?.amount_collected, 2) ?? 0} de {number_format(_x?.amount, 2) ?? 0} </li>
                                                                        </div>
                                                                    )
                                                                })
                                                            ))
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                    {totalRow2}
                                </tbody>
                            </Table>
                        </div>
                    </Card>
                </Col>
                <Col sm="7">
                    <Col sm="12" style={{ backgroundColor: "#f8f9fa", border: "1px #dee2e6", padding: "0.59rem", borderRadius: "6px" }} >
                        <Row>
                            <Col sm="9">
                            </Col>
                            <Col sm="3" className='p-r-0  ' >
                                <Button
                                    icon="icofont icofont-wall-clock f-18"
                                    label="Visualizar calendario"
                                    rounded
                                    severity="success"
                                    aria-label="Search"
                                    onClick={() => handleCalender()}
                                    style={{
                                        padding: "5px 10px",
                                        fontSize: "1rem",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "12px"
                                    }}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col sm="12" className='pt-5 p-r-0' >
                        <div className="chart-container">
                            <Chart type="line" data={data} options={options} />
                        </div>
                    </Col>
                </Col>
            </Row>
        </>
    )

}
